import type { UpdateBanner } from '@/types'
import type { FormCreateBanner } from '@/types/form'
import { createFormData } from '@/utils'
import { type Banner } from '@prisma/client'

import axios from '../axios'
import { tryCatch } from '../catch'

export class BannerService {
  static async findAll(query: BaseQuery) {
    try {
      const response = await axios.get<IPaginate<Banner>>(`/banners`, { params: query })
      if (response.data) {
        return response.data
      }
    } catch (error) {
      tryCatch('`BannerService.findAll`', error)
    }
  }

  static async findOne(id: number) {
    try {
      const response = await axios.get<Banner>(`/banners/${id}`)
      if (response.data) {
        return response.data
      }
    } catch (error) {
      tryCatch('`BannerService.findOne`', error)
    }
  }

  static async create(data: FormCreateBanner) {
    try {
      const [formData, headers] = createFormData(data)
      const response = await axios.post<IResponse>(`/banners`, formData, { headers })
      if (response.data) {
        return response.data
      }
    } catch (error) {
      tryCatch('`BannerService.create`', error)
    }
  }

  static async update(id: number, data: UpdateBanner) {
    try {
      const [formData, headers] = createFormData(data)
      const response = await axios.patch<IResponse>(`/banners/${id}`, formData, { headers })
      return response.data
    } catch (error) {
      tryCatch('`BannerService.update`', error)
    }
  }

  static async delete(id: number) {
    try {
      const response = await axios.delete<IResponse>(`/banners/${id}`)
      return response.data
    } catch (error) {
      tryCatch('`BannerService.delete`', error)
    }
  }
}
